export class SessionModel {
    constructor(
        public id: string,
        public name: string,
        public qrcode: string,
        public workoutId: string,
        public link: string,
    ) { }
}